import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from './authentication.service';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(protected router: Router, protected authService: AuthService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {        
        if (state.url !== '/login' && !this.authService.isAuthenticated()) {
            this.router.navigate(['/login']);
            return false;
        } else {
            if (!this.authService.hasRoles(this.getAclOfRoute(route))) {
                this.router.navigate(['/']);
                return false;
            }
        }

        return true;
    }

    private getAclOfRoute(route: ActivatedRouteSnapshot): string[] {
        if (route.routeConfig.data !== undefined && route.routeConfig.data['roles'] !== undefined) {
            return route.routeConfig.data['roles'];
        }
        return [];
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/authguard.service.ts